import { Modal, Badge, Row, Col } from "react-bootstrap"

const CropViewModal = ({ show, onHide, crop }) => {
  if (!crop) return null

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>🌾 {crop.name} Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {crop.photo && (
          <div className="text-center mb-4">
            <img
              src={crop.photo || "/placeholder.svg"}
              alt={crop.name}
              style={{
                maxWidth: "300px",
                maxHeight: "200px",
                objectFit: "cover",
                borderRadius: "8px",
                border: "1px solid #ddd",
              }}
              onError={(e) => {
                e.target.style.display = "none"
              }}
            />
          </div>
        )}

        <Row>
          <Col md={6}>
            <div className="mb-4">
              <h6 className="text-muted mb-2">BASIC INFORMATION</h6>
              <div className="bg-light p-3 rounded">
                <div className="mb-2">
                  <strong>Crop Name:</strong> {crop.name}
                </div>
                <div className="mb-2">
                  <strong>Growth Period:</strong> {crop.growth_period_days} days
                </div>
                <div>
                  <strong>Soil Type:</strong>{" "}
                  {crop.soil_type ? (
                    <Badge bg="secondary">{crop.soil_type}</Badge>
                  ) : (
                    <span className="text-muted">Not specified</span>
                  )}
                </div>
              </div>
            </div>
          </Col>

          <Col md={6}>
            <div className="mb-4">
              <h6 className="text-muted mb-2">TEMPERATURE REQUIREMENTS</h6>
              <div className="bg-light p-3 rounded">
                <div className="mb-2">
                  <strong>Minimum Temperature:</strong> <Badge bg="info">{crop.min_temp}°C</Badge>
                </div>
                <div className="mb-2">
                  <strong>Maximum Temperature:</strong> <Badge bg="warning">{crop.max_temp}°C</Badge>
                </div>
                <div>
                  <strong>Temperature Range:</strong> <Badge bg="success">{crop.max_temp - crop.min_temp}°C span</Badge>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <div className="mb-4">
          <h6 className="text-muted mb-2">GROWING SEASON ANALYSIS</h6>
          <div className="bg-light p-3 rounded">
            <Row>
              <Col md={4}>
                <div className="text-center">
                  <div className="h4 text-primary">{Math.round(crop.growth_period_days / 30.44)}</div>
                  <small className="text-muted">Months to Harvest</small>
                </div>
              </Col>
              <Col md={4}>
                <div className="text-center">
                  <div className="h4 text-success">{Math.round(crop.growth_period_days / 7)}</div>
                  <small className="text-muted">Weeks to Harvest</small>
                </div>
              </Col>
              <Col md={4}>
                <div className="text-center">
                  <div className="h4 text-info">{(crop.min_temp + crop.max_temp) / 2}°C</div>
                  <small className="text-muted">Optimal Temperature</small>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <div className="mb-4">
          <h6 className="text-muted mb-2">CLIMATE SUITABILITY</h6>
          <div className="bg-light p-3 rounded">
            <div className="mb-2">
              <strong>Climate Type:</strong>{" "}
              {crop.min_temp < 10 && crop.max_temp < 25 ? (
                <Badge bg="primary">Cool Climate</Badge>
              ) : crop.min_temp >= 10 && crop.max_temp <= 30 ? (
                <Badge bg="success">Temperate Climate</Badge>
              ) : (
                <Badge bg="warning">Warm Climate</Badge>
              )}
            </div>
            <div className="mb-2">
              <strong>Season Preference:</strong>{" "}
              {crop.growth_period_days < 90 ? (
                <Badge bg="info">Short Season</Badge>
              ) : crop.growth_period_days <= 120 ? (
                <Badge bg="success">Medium Season</Badge>
              ) : (
                <Badge bg="warning">Long Season</Badge>
              )}
            </div>
            <div>
              <strong>Temperature Tolerance:</strong>{" "}
              {crop.max_temp - crop.min_temp > 20 ? (
                <Badge bg="success">High Tolerance</Badge>
              ) : crop.max_temp - crop.min_temp > 15 ? (
                <Badge bg="warning">Medium Tolerance</Badge>
              ) : (
                <Badge bg="danger">Low Tolerance</Badge>
              )}
            </div>
          </div>
        </div>

        {crop.created_at && (
          <div className="text-muted small">
            <strong>Added:</strong> {new Date(crop.created_at).toLocaleDateString()}
            {crop.updated_at && crop.updated_at !== crop.created_at && (
              <span className="ms-3">
                <strong>Last Updated:</strong> {new Date(crop.updated_at).toLocaleDateString()}
              </span>
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default CropViewModal
